import React, { FC } from 'react';
import { Grid, Badge, Typography } from '@mui/material';
import { CampaignCoupons } from '@models';
import VoucherCard from './VoucherCard';
import UsedVoucherOrderViewModal from './UsedVoucherOrderViewModal';

type Props = {
  coupon: CampaignCoupons;
  campaignName: string;
};

const UsedCouponView: FC<Props> = ({ coupon, campaignName }) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  return (
    <React.Fragment key={coupon.id}>
      {isModalOpen && <UsedVoucherOrderViewModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} couponId={coupon.value} />}
      <Grid item xs={12} sm={6} md={3} onClick={() => setIsModalOpen(true)}>
        <Badge badgeContent={coupon.usageLimit} color="primary" style={{ cursor: 'pointer' }}>
          <VoucherCard data-testid="voucher-card">
            <Grid container>
              <Grid item xs={12}>
                <Typography variant="subtitle1">{campaignName}</Typography>
              </Grid>
              <Grid item xs={12} marginBottom={1}>
                <Typography variant="body1"> {coupon.value}</Typography>
              </Grid>
              {coupon.expiryDate && (
                <Grid item xs={12}>
                  <Typography variant="caption">
                    Expiry on{' '}
                    {new Date(coupon.expiryDate).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                    })}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </VoucherCard>
        </Badge>
      </Grid>
    </React.Fragment>
  );
};

export default UsedCouponView;
